export default {
  'meta': {
    'langName': 'LITHUANIAN',
    'lang': 'Lietuvių'
  },
  'title': ' „TARMAK“ KREPŠINIO LANKO STOVO „B900 BOX NBA“ GAMINIO ATŠAUKIMAS',
  'description': 'Sveiki,\n\n\ndėkojame jums, kad neseniai įsigijote krepšinio lanko stovą „Tarmak B900 BOX NBA“.\n\nVykdydama savo nuolatinį įsipareigojimą dėl mūsų gaminių kokybės ir saugos,  „DECATHLON“  krepšinio komanda nustatė galimą pavojų, kad stulpas gali kristi vertikaliai, jei gaminys būtų naudojamas nuėmus aukščio reguliavimo rankeną.\n\nPrašome atsakyti į kelis klausimus, kad galėtume pateikti jūsų gaminiui tinkamą saugos sprendimą.\n\nDėkojame už jūsų pasitikėjimą ir atsiprašome už patirtus nepatogumus.\n\n„DECATHLON“',
  'emailConfirmation': {
    'title': 'Pirma, patvirtinkite savo el. pašto adresą ir gyvenamosios vietos šalį:\n'
  },
  'fields': {
    'country': 'Šalis',
    'address': 'El. pašto adresas',
    'email': 'El. pašto adresas',
    'phonePrefix': 'Šalies telefono kodas',
    'phone': 'Telefono numeris',
    'validations': {
      'phoneOrEmail': 'Nurodykite bent el. pašto adresą ar telefono numerį.',
      'email': 'Įveskite tinkamą el. pašto adresą',
      'phone': 'Įveskite tinkamą telefono numerį'
    },
    'firstName': 'Pavardė',
    'lastName': 'Vardas',
    'deliveryAddress': 'Siuntos pristatymas adresas',
    'additionalAddress': 'Papildoma adreso informacija',
    'city': 'Miestas',
    'zip': 'Pašto kodas',
    'choose': 'Pasirinkti',
    'required': 'Šis laukas būtinas'
  },
  'ownerCheck': {
    'title': 'Ar vis dar turite vieną arba daugiau „B900 BOX NBA“ krepšinio lanko stovų?\n'
  },
  'yes': 'TAIP',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Ar turite dabartinio (-ių) savininko (-ų) kontaktinius duomenis?',
    'confirmation': 'Gerb. kliente,\n\nlabai vertiname jūsų dalyvavimą šioje kokybės iniciatyvoje.\n\nDėkojame už jūsų pasitikėjimą ir atsiprašome už patirtus nepatogumus.\n\n„DECATHLON“'
  },
  'recall': {
    'title': 'Nurodykite, kiek turite krepšinio lanko stovų, atsižvelgdami į įrengtos rankenos tipą',
    'descriptionRed': 'Krepšinio lanko stovas su nuimama raudona reguliavimo rankena',
    'descriptionBlack': 'Krepšinio lanko stovas su fiksuota juoda reguliavimo rankena',
    'quantity': 'Kiekis',
    'notConcerned': 'Gerb. kliente,\n\nvertiname jūsų dalyvavimą šioje kokybės iniciatyvoje.\n\nSkubame jus patikinti, kad išėmimo iš apyvartos procesas netaikomas jūsų krepšinio lanko stovui „Tarmak B900 BOX NBA“. Jis yra saugus naudoti.\n\nDėkojame už jūsų pasitikėjimą ir atsiprašome už galimus nepatogumus.\n\n„DECATHLON“',
    'concernedProductQuantity': 'Reikalavimų neatitinkančių gaminių kiekis:',
    'concernedProductLabel': 'Reikalavimų neatitinkantis gaminys:',
    'confirmation': 'Dėkojame, kad užpildėte šią formą. Jūsų prašymas sėkmingai užregistruotas.\n\nKuo skubiau pateiksime jums jūsų rinkinio pristatymo sekimo numerį.\n\nLinkime jums geros dienos.\n\n„DECATHLON“'
  },
  'repair': {
    'title': 'Taisymo veiksmai, kuriuos galite atlikti patys',
    'description': 'Nustatėme, kad naudojant tam tikrus krepšinio lanko stovus „TARMAK B900 BOX NBA“, nuorodos Nr. 4239136, su nuimta reguliavimo rankena, kyla pavojus, kad stulpas gali kristi vertikaliai.\nAtsižvelgiant į jūsų atsakymą, panašu, kad ši rizika kyla jūsų gaminiui.\n\nTodėl prašome nedelsiant nustoti juo naudotis. Norime pateikti jums informacijos dėl rankenos pritaikymo taip, kad galėtumėte saugiai naudotis šiuo gaminiu.\nŠiam taisymui atlikti nereikia specialių žinių – viskas yra paprastai paaiškinta toliau pateiktame vaizdo įraše ir instrukcijų vadove:\n',
    'videoLink': 'Vaizdo įrašo nuoroda',
    'docLink': 'Pranešimo nuoroda',
    'callToAction': 'Spustelėkite čia, kad gautumėte nemokamą taisymo rinkinį',
    'warranty': 'Visam procesui taikoma 5 metų garantija.'
  },
  'repairRequest': {
    'title': 'Įveskite toliau informaciją, kad nemokamą rinkinį galėtume išsiųsti jūsų nurodytu adresu:'
  },
  'form': {
    'submit': 'Kitas'
  },
  'status': 'Translation validated by COUNTRY'
} as const
